var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('search-panel-desktop',{staticClass:"search",class:[ _vm.isSearchClosed ? 'closed-search' : 'open-search' ],on:{"blur":_vm.onBlurEvent,"focus":_vm.onFocusEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }